import PropTypes from 'prop-types'
import React from 'react'
import { Alert } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { useReportStillProcessing } from '../../../../../../components/ModalSidebar'
import { isTaskStillProcessing } from '../../../../../../util/hub-task-management/taskStillProcessing'

const propTypes = {
  /**
   * General message stating that the request has failed
   */
  message: PropTypes.node.isRequired,
  /**
   * List of errors that happened
   */
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  /**
   * Set when the parent already renders an alert around this snippet; the parent then picks its color
   * (info while the request is still processing), and this renders only the text
   */
  isInsideAlert: PropTypes.bool,
}

/**
 * Snippet for common submission error use cases
 */
function SubmissionError(props) {
  const { message, errors = [], isInsideAlert = false } = props ?? {}

  const errorsArray = Array.isArray(errors) ? errors : [errors]
  const isStillProcessing = errorsArray.some(isTaskStillProcessing)
  useReportStillProcessing(isStillProcessing)

  if (isStillProcessing && isInsideAlert) {
    return <FormattedMessage id="GENERAL.PROCESSING_IN_BACKGROUND" />
  }

  if (isStillProcessing) {
    return (
      <Alert variant="info">
        <FormattedMessage id="GENERAL.PROCESSING_IN_BACKGROUND" />
      </Alert>
    )
  }

  return (
    <>
      <div>
        <span className="font-color-danger fas fa-circle-xmark me-2" />
        <span className="text-bold">{message}</span>
      </div>
      <ul>
        {errorsArray.map((errorMessage) => (
          <li key={errorMessage}>{errorMessage}</li>
        ))}
      </ul>
    </>
  )
}

SubmissionError.propTypes = propTypes

export default SubmissionError
